import { useTranslation } from 'react-i18next'

import {
  Alert,
  Flex,
  HStack,
  TertiaryButton,
  Text,
  UploadArea,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'

type Props = {
  isOpen: boolean
  onClose: () => void
  onFileSelected: (file: File) => void
}

/**
 * 需要調達計画 XML アップロードのファイルを選択するダイアログ (plan-common.md
 * AC-PLC-007 / procurement-plan-list.md AC-PPL-022〜025)。
 *
 * 承認フロー設定を適用できない注記はファイルを選ぶ前に読めるよう、 計画作成ダイアログと
 * 同じ info Alert で先頭に置く。 ドロップ領域は design `plan/procurement.html`
 * `#pc-import-modal` の `.ecl-upload-area` (DS `UploadArea`)。
 */
export const XmlUploadDialog = ({
  isOpen,
  onClose,
  onFileSelected,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const footer = (
    <HStack justify="flex-end" width="100%">
      <TertiaryButton onClick={onClose} size="md">
        {t('common:action.cancel')}
      </TertiaryButton>
    </HStack>
  )

  return (
    <Modal
      footer={footer}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={t('page:procurementPlanList.uploadDialog.title')}
    >
      <Flex flexDirection="column" gap={4}>
        <Alert
          description={t(
            'page:procurementPlanList.uploadDialog.approvalNotice',
          )}
          status="info"
        />
        <Flex flexDirection="column" gap={2}>
          <UploadArea
            accept=".xml,.zip"
            onSelectFiles={(event, files) => {
              const file = files[0]
              // 同じファイルを続けて選んでも change が発火するよう空に戻す。
              if (event.target instanceof HTMLInputElement) {
                event.target.value = ''
              }
              if (file !== undefined) onFileSelected(file)
            }}
          />
          <Text color="Text.lowEmphasis" fontSize="md" textAlign="center">
            {t('page:procurementPlanList.uploadDialog.acceptedFormats')}
          </Text>
        </Flex>
      </Flex>
    </Modal>
  )
}
